import * as TranscriptService from "../../services/transcript.service";
import FileService from "../../services/file.service";

export const SET_TRANSCRIPTS = 'SET_TRANSCRIPTS';
export const SET_TRANSCRIPT_PAGINATION_INFO = 'SET_TRANSCRIPT_PAGINATION_INFO';
export const SET_TRANSCRIPT = 'SET_TRANSCRIPT';
export const SHOW_TIMESTAMP = 'SHOW_TIMESTAMP';
export const SET_DOWNLOAD_TYPE = 'SET_DOWNLOAD_TYPE';
export const SET_VIEW_MODE = 'SET_VIEW_MODE';
export const SET_TRANSCRIPT_LOADING = 'SET_TRANSCRIPT_LOADING';
export const UPDATE_EDITING_HISTORY = 'UPDATE_EDITING_HISTORY';
export const SET_HISTORY_INDEX = 'SET_HISTORY_INDEX';
export const SET_INITIAL_TRANSCRIPT = 'SET_INITIAL_TRANSCRIPT';
export const SET_EDIT_MODE = 'SET_EDIT_MODE';
export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';

export const getTranscripts = (query) => async (dispatch) => {
  dispatch(setLoading(true));

  try {
    const res = await TranscriptService.getTranscripts(query);
    dispatch(setTranscripts(res.data.data));
    if (res.data._metadata) {
      dispatch(setTotalCount(parseInt(res.data._metadata.total_count, 10)));
    }
  } catch (e) {
    dispatch(setLoading(false));
    throw (e);
  }
};

export const getTranscript = (id) => async (dispatch) => {
  dispatch(setLoading(true));

  try {
    let res;
    res = await TranscriptService.getTranscriptById(id);
    dispatch(setTranscript(res.data));
    dispatch(setInitialTranscript(res.data));
  } catch (e) {
    dispatch(setLoading(false));
    throw (e);
  }
};

export const setTranscripts = (value) => ({
  type: SET_TRANSCRIPTS,
  payload: { transcripts: value }
});

export const setPaginationInfo = (value) => async (dispatch, getState) => {
  const paginationInfo = getState().transcriptsReducer.paginationInfo;
  Object.assign(paginationInfo, value);
  dispatch({
    type: SET_TRANSCRIPT_PAGINATION_INFO,
    payload: { paginationInfo: { ...paginationInfo} }
  })
};

export const setTotalCount = (value) => ({
  type: SET_TOTAL_COUNT,
  payload: value
});


export const setTranscript = (value) => ({
  type: SET_TRANSCRIPT,
  payload: { transcript: {...value} }
});

export const setInitialTranscript = (value) => ({
  type: SET_INITIAL_TRANSCRIPT,
  payload: {transcript: {...value}}
});

export const setShowTimestamp = (value) => ({
  type: SHOW_TIMESTAMP,
  payload: value
});

export const setDownloadType = (value) => ({
  type: SET_DOWNLOAD_TYPE,
  payload: value
});

export const setViewMode = (value) => ({
  type: SET_VIEW_MODE,
  payload: value
});

export const setLoading = (value) => ({
  type: SET_TRANSCRIPT_LOADING,
  payload: value
});

export const updateHistory = (value) => ({
  type: UPDATE_EDITING_HISTORY,
  payload: value
});

export const setHistoryIndex = (value) => ({
  type: SET_HISTORY_INDEX,
  payload: value
});

export const moveRecordings = (recordingIds, node_id) => async (dispatch)=> {
  dispatch(setLoading(false));

  // eslint-disable-next-line no-unused-vars
  for (const recordingId of recordingIds) {
    await FileService.moveRecording(recordingId, node_id);
  }
};

export const archiveRecordings = (recordingIds) => async (dispatch)=> {
  dispatch(setLoading(false));

  // eslint-disable-next-line no-unused-vars
  for (const recordingId of recordingIds) {
    await FileService.archiveRecording(recordingId);
  }
};

export const toggleEditMode = (value) => ({
  type: SET_EDIT_MODE,
  payload: value
});
